
export const APIGetFirstwupuap = async (token, tablename, pagesize, sortby, sortorder) => {

    try {
        const url ="https://portal.ttpadvisory.co.uk:3556/api/crm/getfirst";
        const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify({tablename, pagesize, sortorder,sortby})
        };
        const res = await fetch(url, requestOptions)
        if(res.status ===200) {
            const ret = await res.json()
            return ret
        }
        return {status: false, data: [], err: `HTTP Error ${res.status}`}
    }catch(err ) {
        return {status: false, data: [], err: `Catch Error ${err}`}
    }
}

export const APIGetData = async (params) => {

    try {
        const url ="https://portal.ttpadvisory.co.uk:3556/api/crm/getdata";
        const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + params.token
        },
        body: JSON.stringify(params)
        };
        const res = await fetch(url, requestOptions)
        if(res.status ===200) {
            const ret = await res.json()
            return ret
        }
        return {status: false, data: [], err: `HTTP Error ${res.status}`}
    }catch(err ) {
        console.log(`Catch Error!!`)
        console.log(err)
        return {status: false, data: [], err: `Catch Error ${err}`}
    }
}

export const APIGetNotes  = async (params) => {
    console.log(`in APIGetNotes`)
    try {
        const url =`https://portal.ttpadvisory.co.uk:3556/api/crm/getnotes/${params.ttp_lead_id}`;
        const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + params.token
        },
        body: JSON.stringify(params)
        };
        console.log(`Call get Notes`)
        const res = await fetch(url, requestOptions)
        console.log(`Call get Notes RETURNED with `, res)
        if(res.status ===200) {
            const ret = await res.json()
            console.log(`res.json() returned `, ret)

            return ret
        }
        console.log(`error res was set to `, res)
        return {status: false, data: [], err: `HTTP Error ${res.status}`}
    }catch(err ) {
        console.log(`Catch Error!!`)
        console.log(err)
        return {status: false, data: [], err: `Catch Error ${err}`}
    }
}

export const APIAddNote = async (params) => {

    try {
        const url ="https://portal.ttpadvisory.co.uk:3556/api/crm/addnote";
        const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + params.token
        },
        body: JSON.stringify(params)
        };
        const res = await fetch(url, requestOptions)
        if(res.status ===200) {
            const ret = await res.json()
            return ret
        }
        return {status: false, data: [], err: `HTTP Error ${res.status}`}
    }catch(err ) {
        console.log(`Catch Error!!`)
        console.log(err)
        return {status: false, data: [], err: `Catch Error ${err}`}
    }
}

// Phones
export const APIGetPhoneCalls  = async (params) => {

    try {
        const url =`https://portal.ttpadvisory.co.uk:3556/api/crm/getphonecalls/${params.ttp_lead_id}`;
        const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + params.token
        },
        body: JSON.stringify(params)
        };
        const res = await fetch(url, requestOptions)
        if(res.status ===200) {
            const ret = await res.json()
            return ret
        }
        return {status: false, data: [], err: `HTTP Error ${res.status}`}
    }catch(err ) {
        console.log(`Catch Error!!`)
        console.log(err)
        return {status: false, data: [], err: `Catch Error ${err}`}
    }
}

export const APIAddPhoneCall = async (params) => {

    try {
        const url ="https://portal.ttpadvisory.co.uk:3556/api/crm/addphonecall";
        const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + params.token
        },
        body: JSON.stringify(params)
        };
        const res = await fetch(url, requestOptions)
        if(res.status ===200) {
            const ret = await res.json()
            return ret
        }
        return {status: false, data: [], err: `HTTP Error ${res.status}`}
    }catch(err ) {
        console.log(`Catch Error!!`)
        console.log(err)
        return {status: false, data: [], err: `Catch Error ${err}`}
    }
}

